import { NgModule } from '@angular/core';
import { DurationPipe } from './duration/duration';
import { CharacterCountPipe } from './character-count/character-count';
import { ArraySortPipe } from './sorting/ArraySort';

@NgModule({
  declarations: [DurationPipe, CharacterCountPipe, ArraySortPipe],
  imports: [],
  exports: [DurationPipe, CharacterCountPipe, ArraySortPipe]
})
export class PipesModule {
}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts